import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Copy, ExternalLink, LogOut } from 'lucide-react';
import { useAccount, useDisconnect } from 'wagmi';
import toast from 'react-hot-toast';
import './WalletModal.css';

const WalletModal = ({ isOpen, onClose, unlockedCount = 0 }) => {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  const copyAddress = () => {
    if (address) {
      navigator.clipboard.writeText(address);
      toast.success('Address copied to clipboard');
    }
  };

  const openExplorer = () => {
    if (address) {
      window.open(`https://basescan.org/address/${address}`, '_blank');
    }
  };

  const handleDisconnect = () => {
    disconnect();
    onClose();
    toast.success('Wallet disconnected');
  };

  if (!address) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="wallet-modal"
            initial={{ opacity: 0, scale: 0.9, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 50 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Wallet Account</h3>
              <button className="close-button" onClick={onClose}>
                <X size={20} />
              </button>
            </div>

            <div className="modal-content">
              <div className="account-info">
                <div className="account-address">
                  <span className="address-label">Address</span>
                  <div className="address-display">
                    <span className="address-text">
                      {address?.slice(0, 6)}...{address?.slice(-4)}
                    </span>
                    <div className="address-actions">
                      <button
                        className="icon-button"
                        onClick={copyAddress}
                        title="Copy address"
                      >
                        <Copy size={16} />
                      </button>
                      <button
                        className="icon-button"
                        onClick={openExplorer}
                        title="View on BaseScan"
                      >
                        <ExternalLink size={16} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="unlocked-info">
                  <span className="unlocked-label">Unlocked Confessions</span>
                  <span className="unlocked-value">
                    {unlockedCount} {unlockedCount === 1 ? 'confession' : 'confessions'}
                  </span>
                </div>
              </div>

              <div className="modal-actions">
                <motion.button
                  className="btn btn-danger disconnect-button"
                  onClick={handleDisconnect}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <LogOut size={16} />
                  Disconnect Wallet
                </motion.button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WalletModal;